import {
  BookOpen, GraduationCap, Palette, Scissors, Hammer, Wrench, ChefHat, Music,
  Camera, Code, Calculator, FlaskConical, Leaf, HeartPulse, Dumbbell, Brush,
  Shirt, Sparkles, Briefcase, Globe, Languages, Car, Zap, Sprout,
} from 'lucide-react';

export const COURSE_ICONS = {
  BookOpen, GraduationCap, Palette, Scissors, Hammer, Wrench, ChefHat, Music,
  Camera, Code, Calculator, FlaskConical, Leaf, HeartPulse, Dumbbell, Brush,
  Shirt, Sparkles, Briefcase, Globe, Languages, Car, Zap, Sprout,
};

export const getCourseIcon = (name) => COURSE_ICONS[name] || BookOpen;
